<template>
  <div class="flex flex-col">
    <searchNav :reset="reset" @setSearch="setSearch" />
    <section id="search">
      <md-progress-bar
        v-if="loading"
        style="position:absolute;top:0;left:0;right:0;"
        md-mode="indeterminate"
      />
      <priceFilter :searchFilter="searchFilter" :reset="reset" @setPrice="setPrice" />
      <cars :loading="loading" :cars="cars" @resetFilters="resetFilters" />
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import searchNav from "../components/navigation/SearchNav";
import priceFilter from "../components/findyourcar/pricefilter";
import cars from "../components/findyourcar/cars";

export default {
  components: {
    priceFilter,
    cars,
    searchNav
  },
  data: () => ({
    reset: false
  }),
  methods: {
    setPrice(query) {
      this.$store.commit("setPrice", query);
      this.fetchCars();
    },
    setSearch(query) {
      this.$store.commit("setSearch", query);
      this.fetchCars();
    },
    resetFilters() {
      this.reset = true; //allow child components to reset their fields
      this.$store.commit("resetFilters");
      this.fetchCars();
    },
    ...mapActions(["fetchCars"])
  },
  computed: {
    ...mapState(["cars", "searchFilter", "loading"])
  },
  created() {
    if (!this.loading && !this.cars.length && !this.searchFilter) {
      this.fetchCars();
    }
  },
  watch: {
    reset() {
      if (this.reset === true) {
        setTimeout(() => {
          this.reset = false;
        }, 0);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#search {
  position: relative;
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
}
</style>